import { FadeUp } from "./Reveal";
import { useLang } from "@/i18n";

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section id="progetto" className="bg-ivory py-28 sm:py-40" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-10">
        <FadeUp>
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-terracotta">{t.manifesto.label}</p>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="mt-6 max-w-4xl font-serif text-4xl font-light leading-[1.15] tracking-tight text-ink sm:text-6xl">
            {t.manifesto.h2a}
            <em className="italic text-terracotta">{t.manifesto.h2em}</em>
            {t.manifesto.h2b}
          </h2>
        </FadeUp>

        <div className="mt-24 sm:mt-32">
          {t.manifesto.chapters.map((c, i) => (
            <FadeUp key={c.n} delay={0.05 * i} data-testid={`manifesto-chapter-${c.n}`}>
              <div className="grid grid-cols-1 gap-6 border-t border-line py-14 md:grid-cols-12 md:py-20">
                <div className="md:col-span-2">
                  <span className="font-serif text-6xl font-light text-sand sm:text-7xl">{c.n}</span>
                </div>
                <div className="md:col-span-8 md:col-start-4">
                  <h3 className="font-serif text-2xl font-medium text-ink sm:text-3xl">{c.t}</h3>
                  <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#4A4F4C] sm:text-lg">{c.d}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
